/*
 * @Author:
 * @LastEditTime: 2022-02-23 14:01:49
 * @Description:
 */
import To from 'await-to-js'
import Callback from './OidcCallback'

export default class Common {
  // 获取站点信息
  static async getSites() {
    const [err, res] = await To(wizModuleInstance.get('/api/Sites/GetSitesAsync'))
    return Callback(err, res)
  }
  static async uploadFile(payload) {
    const [err, res] = await To(
      wizModuleInstance.post(payload.reqUrl, payload.reqData, {
        'Content-Type': 'multipart/form-data',
      })
    )
    return Callback(err, res)
  }
}
